import { useRef } from 'react';
import ColumnWithVirtualization from './ColumnWithVirtualization';
import { COLUMN_WIDTH } from './constants';
import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
// This margin tells the UIIntersectionObserver to consider the column
// intersecting (aka in view) one column width in advance of it actually
// being on the screen. This allows the next column to start rendering before
// the user sees it.
import { jsx as _jsx } from "react/jsx-runtime";
const rootMargin = `0px ${COLUMN_WIDTH}px`;
const ColumnWithIntersectionObserver = ({
  columnId,
  columnData,
  isBoardEmpty
}) => {
  const targetRef = useRef(undefined);
  return /*#__PURE__*/_jsx(IntersectionObserver, {
    root: targetRef.current,
    rootMargin: rootMargin,
    onIntersectionChange: ({
      entries,
      observer
    }) => {
      if (entries[0].isIntersecting) {
        // Disconnect observer once the element is rendered
        observer.disconnect();
      }
    },
    renderContent: isIntersecting => /*#__PURE__*/_jsx(ColumnWithVirtualization, {
      columnData: columnData,
      isBoardEmpty: isBoardEmpty,
      isColumnVisible: !!isIntersecting
    })
  }, columnId);
};
export default ColumnWithIntersectionObserver;